import type { ReactNode } from 'react';
import CompactPageHero from './CompactPageHero';

interface DocumentPageShellProps {
  eyebrow?: string;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

export default function DocumentPageShell({
  eyebrow,
  title,
  subtitle,
  children,
}: DocumentPageShellProps) {
  return (
    <main className="min-h-screen bg-[#f3f3f3] font-figtree">
      <CompactPageHero>
        {eyebrow ? (
          <span className="mb-4 inline-block font-figtree text-[9px] font-bold uppercase tracking-[0.32em] text-[#E31E24]">
            {eyebrow}
          </span>
        ) : null}
        <h1 className="hero-title text-white">{title}</h1>
        {subtitle ? (
          <div className="mt-3 hero-subtitle text-white/60 sm:mt-4">{subtitle}</div>
        ) : null}
      </CompactPageHero>

      <div className="relative z-[1] bg-[#f3f3f3]">
        <div className="container mx-auto py-10 max-sm:px-4 sm:py-12 md:py-14">{children}</div>
      </div>
    </main>
  );
}
